import { connect } from 'react-redux';
import { getConversationOverviewBulkValidationForSelected } from 'components/conversationsOverview/selectors/conversationOverview';
import { hasFeature } from 'components/shared/featureFlag';
import bulkActionsActions from '../actions/bulkActions';
import { BulkActionsModal, } from '../components/bulkActionsModal';
import { getBulkActionsIsModalOpen, getBulkActionsLocation, getBulkConversationIDs, getInternalNote, getReplyMessage, getSelectedActions, getSelectedQueue, getSelectedTagsToAdd, getSelectedTagsToRemove, getUnselectedActions, } from '../selectors/bulkActions';
const { bulkActionsCloseModal, bulkActionsAddAction, bulkActionsRemoveAction, bulkActionsSetTagsAdd, bulkActionsSetTagsRemove, bulkActionsSetReplyMessage, bulkActionsSetQueue, bulkActionsSetInternalNote, bulkActionsStart, } = bulkActionsActions;
const mapStateToProps = (state) => ({
    isOpen: getBulkActionsIsModalOpen(state),
    selectedActions: getSelectedActions(state),
    unselectedActions: getUnselectedActions(state),
    csids: getBulkConversationIDs(state),
    selectedTagsToAdd: getSelectedTagsToAdd(state),
    selectedTagsToRemove: getSelectedTagsToRemove(state),
    replyMessage: getReplyMessage(state),
    bulkValidation: getConversationOverviewBulkValidationForSelected(state),
    selectedQueue: getSelectedQueue(state),
    internalNote: getInternalNote(state),
    hasHighLimitBulkActions: hasFeature(state, 'high-limit-bulk-actions-core'),
    location: getBulkActionsLocation(state),
});
const mapDispatchToProps = (dispatch) => ({
    addAction: (action) => dispatch(bulkActionsAddAction(action)),
    removeAction: (action) => dispatch(bulkActionsRemoveAction(action)),
    close: () => dispatch(bulkActionsCloseModal()),
    onAddTagsSelectionChanged: (selection) => dispatch(bulkActionsSetTagsAdd(selection)),
    onRemoveTagsSelectionChanged: (selection) => dispatch(bulkActionsSetTagsRemove(selection)),
    setReplyMessage: (message) => dispatch(bulkActionsSetReplyMessage(message)),
    setSelectedQueue: (queue) => dispatch(bulkActionsSetQueue(queue)),
    setInternalNote: (note) => dispatch(bulkActionsSetInternalNote(note)),
    start: () => dispatch(bulkActionsStart()),
});
export default connect(mapStateToProps, mapDispatchToProps)(BulkActionsModal);
